import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";

type DetailNotesCardProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  dirty: boolean;
  saving?: boolean;
  placeholder?: string;
  title?: string;
  description?: string;
};

export function DetailNotesCard({
  id,
  value,
  onChange,
  onSave,
  dirty,
  saving = false,
  placeholder = "Team notes…",
  title = "Internal notes",
  description = "Private scratch pad for your team. Use Activity for discussion.",
}: DetailNotesCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Textarea
          id={id}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          rows={6}
          placeholder={placeholder}
        />
        <div className="flex items-center justify-between gap-2">
          <p className="text-xs text-muted-foreground">{dirty ? "Unsaved changes" : "Saved"}</p>
          <Button size="sm" disabled={!dirty || saving} onClick={onSave}>
            Save notes
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
